import { createAsyncThunk } from "@reduxjs/toolkit";
import overallReportingApi from "app/api/overallReporting";

// (1) branch -- start
export const getFilterBranchesData = createAsyncThunk(
    "reporting/getBranchesData",
    async (payload, thunkApi) => {
        return overallReportingApi.getFilterBranchesData(payload)
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
);
// (1) branch -- end

// (2) country city -- start
export const getFilterCountryCityData = createAsyncThunk(
    "reporting/getFilterCountryCityData",
    async (payload, thunkApi) => {
        return overallReportingApi.getFilterCountryCityData(payload)
            .then((response) => response)
            .catch((error) => thunkApi.rejectWithValue(error));
    }
);
// (2) country city -- end